export default {"src":"//prod.smassets.net/assets/smweb/_next/static/media/perks-icon-white.120915aa.svg","height":92,"width":69,"blurWidth":0,"blurHeight":0};